import { useQuery } from "@tanstack/react-query";

import { FETCH_ERROR } from "../consts/fetch-error";
import { getPages } from "../services/page";
import { useLocale } from "../stores/locale";

export function useGetPages() {
  const { currentLanguage } = useLocale();

  return useQuery({
    queryKey: ["pages", currentLanguage],
    queryFn: () => getPages(currentLanguage),
    staleTime: 1000 * 60 * 60, // 1 hour
    retry: (_failureCount, error: unknown) =>
      error !== FETCH_ERROR.UNAUTHORIZED,
  });
}
